<template>
  <div class="child-content">
    <div
      class="news-item"
      v-for="(item, index) in newsList"
      :key="index"
      @click="onDetailClick(item)"
    >
      <div class="item-img">
        <img
          :src="item.cover || require('@/assets/images/icon-12.png')"
          alt="图片"
        />
      </div>
      <div class="item-content">
        <div class="item-title">{{ item.articleName }}</div>
        <div class="item-desc">{{ getSummary(item.articleContent) }}</div>
      </div>
      <div class="item-date">{{ item.releaseTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageNews',
  props: {
    newsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    onDetailClick(item) {
      this.$emit('handleBannerClick', item)
    },
    // 提取纯文本摘要
    getSummary(content) {
      if (!content) return ''
      // 去除HTML标签，获取纯文本
      const text = content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()
      // 截取前120个字符
      return text.length > 120 ? text.substring(0, 120) + '...' : text
    }
  }
}
</script>

<style scoped lang="scss">
.child-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 34px;
  .news-item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    .item-img {
      width: 100px;
      height: 100px;
      margin-right: 20px;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    .item-content {
      flex: 1;
      min-width: 0;
      .item-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 10px;
        line-height: 1.4;
      }
      .item-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
        margin-bottom: 10px;
      }
    }
    .item-date {
      font-size: 14px;
      color: #999;
      flex-shrink: 0;
      margin-left: 20px;
      white-space: nowrap;
      margin-top: 80px;
    }
  }
}

// 手机端css
.mobile-content {
  .child-content {
    margin-top: 20px;
    gap: 15px;
    .news-item {
      padding: 15px;
      flex-direction: column;
      .item-img {
        width: 100%;
        height: 150px;
        margin-right: 0;
        margin-bottom: 15px;
      }
      .item-content {
        margin-bottom: 10px;
      }
      .item-date {
        margin-left: 0;
        align-self: flex-start;
      }
    }
  }
}
</style>
